// Client wrapper for /api/simplify. Caches the result per question id so a second
// tap on "Simplify" doesn't burn another API call.

export interface SimplifyResult {
  simplified: string;
  isMultiPart: boolean;
  steps: string[];
}

const cache = new Map<string, SimplifyResult>();

export async function simplifyQuestion(input: {
  questionId: string;
  questionText: string;
  context?: string;
  yearLevel?: string;
}): Promise<SimplifyResult> {
  const cached = cache.get(input.questionId);
  if (cached) return cached;

  const response = await fetch('/api/simplify', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      questionText: input.questionText,
      context: input.context,
      yearLevel: input.yearLevel,
    }),
  });
  if (!response.ok) {
    const detail = await response.text();
    throw new Error(`Simplify failed (${response.status}): ${detail.slice(0, 200)}`);
  }
  const body = (await response.json()) as SimplifyResult;
  const result: SimplifyResult = {
    simplified: body.simplified ?? '',
    isMultiPart: Boolean(body.isMultiPart),
    steps: Array.isArray(body.steps) ? body.steps : [],
  };
  cache.set(input.questionId, result);
  return result;
}

export function clearSimplifyCache(): void {
  cache.clear();
}
